import { batch, useComputed } from "@suse-o11y/signal";
import React from "react";
import { usePrevious } from "react-use";

import { FormState } from "../../widget-form/form-state";

import { BarChart } from "./bar-chart";
import { GaugeChart } from "./gauge-chart";
import { StatChart } from "./stat-chart";
import { TimeSeriesChart } from "./time-series-chart";

export interface SettingsProps {
	settings: FormState;
}

export const Settings: React.FC<SettingsProps> = ({ settings }) => {
	const kind = useComputed((monitor) => settings.active.getOutput(monitor), [settings]);
	const previousKind = usePrevious(kind);

	React.useEffect(() => {
		if (previousKind != null) {
			batch((monitor) => {
				const sync = FormState.toSync(previousKind, settings.getInput(monitor).branches);

				settings.setInput({
					branches: FormState.fromSync(sync),
				});
			});
		}
	}, [previousKind, settings]);

	switch (kind) {
		case "TimeSeriesChart": {
			return <TimeSeriesChart settings={settings.branches.TimeSeriesChart} />;
		}

		case "BarChart": {
			return <BarChart settings={settings.branches.BarChart} />;
		}

		case "GaugeChart": {
			return <GaugeChart settings={settings.branches.GaugeChart} />;
		}

		case "StatChart": {
			return <StatChart settings={settings.branches.StatChart} />;
		}

		default: {
			return null;
		}
	}
};
